<template>
  <div class="py-12 lg:py-20">
    <div class="bg-theme-light rounded-lg py-10 text-center">
      <img src="@/assets/images/profileVerified.png" class="mx-auto">
      <div class="py-6 text-lg font-medium px-5">
        <p class="text-blue text-xl pb-2">Congratulations!</p>
        <p class="text-blue text-xl pb-2">Your Profile is now online.</p>
        <br/>
        <p>
          If you need to update any information, please <a :href="contactUrl" class="text-blue underline underline-offset-2">Contact Us.</a>
        </p>
        <p>
          We will contact you as soon as we have a Buyer Order that matches your Profile.
        </p>
      </div>
      <p class="text-lg font-medium pt-4"> <a :href="contactUrl" style="cursor: pointer;" class="text-blue underline underline-offset-2"> Contact Us</a> | <a @click="signOut" style="cursor: pointer;" class="text-blue underline underline-offset-2">Logout</a></p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '@/store/index'

export default {
  name: 'ProfileVerified',
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Your Profile has been Activated - BuyHive'
    console.log('profile verified', store.getters)
    if (!store.getters.isUserLoggedIn || store.getters.getUserAuthInfo.role === 'buyer') {
      // next({ name: 'Home' })
      console.log('profile verified if')
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    } else if (!store.getters.getIsEmailVerified) {
      console.log('profile verified else if')
      next({ name: 'EmailVerification' })
    } else if (store.getters.getIsEmailVerified && !store.getters.getUserAuthInfo.profileVerified) {
      console.log('profile verified else if 2')
      next({ name: 'AccountReview' })
    } else {
      console.log('profile verified else')
      next()
    }
  },
  watch: {
    // getIsEmailVerified(val) {
    //   if (val) this.$router.push({ name: 'AccountReview' })
    // }
  },
  computed: {
    ...mapGetters ([ 'getUserAuthInfo', 'getIsEmailVerified', 'getIsProfileActivated' ])
  },
  data() {
    return {
      sendingEmail: false,
      contactUrl: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/contact-us?enquiry_type=Expert Sourcing`
    }
  },
  methods: {
    ...mapActions ([
      'resendAccountVerificationEmail',
      'logout'
    ]),
    async signOut() {
      await this.logout()
      // this.$router.push({ name: 'Home' })
      window.location = process.env.VUE_APP_SERVER_BASE_URL
    },
  }
}
</script>
